import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { Injectable } from '@angular/core';
import { ApplicationNavigationService } from 'app/services/shell/application-navigation/application-navigation.service';
import { allowedApps } from '../data/allowedApps';
import { CloseMe } from '@itero/itero-client-communication';
import { BaseShellEvent } from './base-shell-event';

@Injectable({ providedIn: 'root' })
export class CloseMeEvent extends BaseShellEvent<CloseMe> {
	constructor(private applicationNavigationService: ApplicationNavigationService) {
		super();
	}

	get eventName(): string {
		return ShellCommunicationEvents.CloseMe;
	}

	handleCustomEvent(event: CloseMe) {
		if (allowedApps.includes(event.eventHeader.publisher)) {
			this.applicationNavigationService.navigateBack(event.eventHeader.publisher);
		}
		super.handleCustomEvent(event);
	}
}
